const initialState = {
  currentUser: null,
  clientData: null
};

export const currentUserReducer = (state = initialState, action) => {
  switch (action.type) {
    case "LOG_IN":
      return {
        ...state,
        currentUser: action.payload,
      };
    case "LOG_OUT":
      return {
        currentUser: null,
        clientData: null,
      };
    case "SET_CLIENT":
      return {
        ...state,
        clientData: action.payload,
      };
    case "UPDATE_PROFILE":
      return {
        ...state,
        currentUser: { ...state.currentUser, ...action.payload },
      };
    default:
      return state;
  }
};